import {
  HOME_STRIPE_PAYMENT_BEGIN,
  HOME_STRIPE_PAYMENT_SUCCESS,
  HOME_STRIPE_PAYMENT_FAILURE,
  HOME_STRIPE_PAYMENT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderAuthHeader } from '../../common/utils/auth';
export function stripePayment(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_STRIPE_PAYMENT_BEGIN,
    });
    const { planType, priceId } = args;
    const config = builderAuthHeader();
    config.headers['Access-Control-Allow-Origin'] = '*';
    const body = { subscriptionType: planType, priceId };
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_ORGANIZATION_ENGINE_URL}payment/create-org-session`,
        body,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_STRIPE_PAYMENT_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: HOME_STRIPE_PAYMENT_FAILURE,
            data: { error: err },
          });
          reject(err);
          console.log('error>>>>>stripePayment', err);
        },
      );
    });

    return promise;
  };
}

export function dismissStripePaymentError() {
  return {
    type: HOME_STRIPE_PAYMENT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_STRIPE_PAYMENT_BEGIN:
      return {
        ...state,
        stripePaymentPending: true,
        stripePaymentError: null,
      };

    case HOME_STRIPE_PAYMENT_SUCCESS:
      return {
        ...state,
        stripePaymentPending: false,
        stripePaymentError: null,
      };

    case HOME_STRIPE_PAYMENT_FAILURE:
      return {
        ...state,
        stripePaymentPending: false,
        stripePaymentError: action.data.error,
      };

    case HOME_STRIPE_PAYMENT_DISMISS_ERROR:
      return {
        ...state,
        stripePaymentError: null,
      };

    default:
      return state;
  }
}
